import {ModalBody} from "@/components/modal/index";
import styled from "styled-components";
import {observer} from "mobx-react";
import {useStore} from "@/store";
import React, {useEffect, useState} from "react";
import Table from "@/components/common/Tabel";
import Pagination from "@/components/common/Pagination";
import {getNewsSubscribeList} from "@/app/admin/(protected)/news/controller";
import DownIcon from "/public/assets/icons/down-ico.png";
import Input from "@/components/common/Input";
import {exportToExcelSync, setToast} from "@/utils";
import {IoCloseCircle, IoSearch} from "react-icons/io5";
import {SearchWrapper02} from "@/styles/CommonStyle";
import Button from "@/components/common/Button";
import moment from "moment";


const NewsSubscribeDetailModal = observer(() => {
    const {boardDetailStore, confirmStore, loadingStore} = useStore();
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(50);
    const [searchString, setSearchString] = useState("");
    const [searchStateString, setSearchStateString] = useState("");
    const [searchState, setSearchState] = useState(false);
    useEffect(() => {
        boardDetailStore.setSubscribeList().then();
    }, []);
    const setDraw = async (offset, limit, clear = false) => {
        if(clear){
            await boardDetailStore.setSubscribeList(0, 50, "");
            setSearchString("");
        }else{
            await boardDetailStore.setSubscribeList(offset, limit, searchString);
        }
        boardDetailStore.searchBaseStore.setDeleteCheckedTypeMap("subscribeList");
    }
    return(
        <ModalBody>
            <NewsSubscribeDetailWrap>
                <div className={"control-wrapper"}>
                    <SearchWrapper02>
                        <div className={"search-content"}>
                            <div className={"select-type"}>
                                이메일
                            </div>
                            <div className={"search-area"}>
                                <Input
                                    inputType="text"
                                    placeholder="입력해주세요"
                                    width={"fill"}
                                    value={searchString}
                                    onChange={(e) => {
                                        setSearchString(e.target.value);
                                    }}
                                    onKeyDown={async (e) => {
                                        if (e.key === "Enter") {
                                            if (!searchString) {
                                                setToast("warning", "검색어 입력후 검색해주세요.");
                                                return;
                                            }
                                            await setDraw(0, limit, false);
                                        }
                                    }}
                                />
                                {
                                    boardDetailStore.searchSubscribeState === searchString && boardDetailStore.searchSubscribeState !== "" ?
                                        <div className={"close-btn"}
                                             onClick={async () => {
                                                 await setDraw(0, limit,true);
                                             }}
                                        >
                                            <IoCloseCircle color={"#999999"} size={24}/>
                                        </div>
                                        :
                                        <div
                                            className={"search-btn"}
                                            onClick={async () => {
                                                if (!searchString) {
                                                    setToast("warning", "검색어 입력후 검색해주세요.");
                                                    return;
                                                }
                                                await setDraw(0, limit, false);
                                            }}
                                        ><IoSearch color={"#999999"} size={24}/></div>
                                }
                            </div>
                        </div>
                    </SearchWrapper02>
                    <div className={"control-inner jc-between"}>
                        <Button
                            type="solid"
                            size="m"
                            text="삭제"
                            round={true}
                            onClickFunc={async () => {
                                if (!boardDetailStore.searchBaseStore.checkedMap["subscribeList"] || boardDetailStore.searchBaseStore.checkedMap["subscribeList"].length === 0) {
                                    setToast("warning", "삭제할 항목을 선택해 주세요.");
                                    return;
                                }
                                try {
                                    confirmStore.openConfirm({
                                        confirmText: "확인",
                                        text: "선택한 항목을 삭제 하시겠습니까?",
                                        cancelText: "취소",
                                        confirmFunc: async () => {
                                            const response = await boardDetailStore.setDeleteSubscribe("subscribeList", boardDetailStore.newsSubscribeList);
                                            if (response) {
                                                let page = offset;
                                                if(parseInt(offset) !== 0){
                                                    if (boardDetailStore.newsSubscribeList.length === 1 || boardDetailStore.newsSubscribeList.length === boardDetailStore.searchBaseStore.checkedMap["subscribeList"].length) {
                                                        page = offset - 1;
                                                    }
                                                }
                                                setOffset(page);
                                                setToast("success", "항목이 삭제 되었습니다.");
                                                await boardDetailStore.setSubscribeList(offset, limit);
                                                boardDetailStore.searchBaseStore.setDeleteCheckedTypeMap("subscribeList");
                                                confirmStore.clear();
                                            }
                                        },
                                        cancelFunc: () => confirmStore.clear(),
                                    });
                                } catch (e) {
                                    console.log(e)
                                }
                            }}
                        />
                        <div className={"flex al-center gap-10"}>
                            {
                                boardDetailStore.searchSubscribeState &&
                                <span className={"search-word"}>검색된 내용: {boardDetailStore.searchSubscribeState}</span>
                            }
                            <Button
                                type="fill"
                                size="m"
                                text={`${!boardDetailStore.searchSubscribeState ? "전체 다운로드" : "검색 다운로드"}`}
                                round={true}
                                icon={() => <img src={DownIcon?.src} alt={"다운로드"}/>}
                                onClickFunc={async () => {
                                    if(boardDetailStore.newsSubscribeList && boardDetailStore.newsSubscribeList.length <= 0){
                                        setToast("warning", "다운로드 할 데이터가 없습니다.")
                                        return;
                                    }
                                    try {
                                        loadingStore.startLoading();
                                        loadingStore.setLoadingState(true);
                                        const downList = await boardDetailStore.setDownLoadSubscribe(boardDetailStore.newsSubscribeTotalCount);
                                        // console.log(downList, "downList")
                                        const emailData = downList.map((email, index) => ({
                                            num: index + 1,
                                            email,
                                        }));
                                        await exportToExcelSync(emailData, EXCEL_NEWS_COLUMNS, `이메일 구독 리스트_${moment().format("YYYY-MM-DD HH.mm")}.xlsx`);
                                        setToast("success", "엑셀 다운로드 완료.");
                                    } finally {
                                        loadingStore.setLoadingState(false);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={"table-wrap"}>
                    <Table
                        data={boardDetailStore.newsSubscribeList}
                        columns={getNewsSubscribeList}
                        store={boardDetailStore}
                        checkType={"subscribeList"}
                        offset={offset}
                        dataAllCount={boardDetailStore.newsSubscribeTotalCount}
                    />
                    {
                        boardDetailStore.newsSubscribeTotalCount > limit &&
                        <Pagination
                            totalItems={boardDetailStore.newsSubscribeTotalCount ?? 0}
                            itemCountPerPage={limit}
                            pageCount={10}
                            currentPage={offset}
                            setPageIndex={async (pageNumber) => {
                                setOffset(pageNumber)
                            }}
                            setPage={async (offset) => {
                                await setDraw(offset, limit, false);
                            }}
                        />
                    }
                </div>
            </NewsSubscribeDetailWrap>
        </ModalBody>
    )
});
const NewsSubscribeDetailWrap = styled.div`
    .control-inner{
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 16px 0;
    }
    .select-type{
        padding:  0 16px;
    }
    .search-word{
        color: #ccc;
        font-size: 14px;
        font-weight: 400;
    }
`

const EXCEL_NEWS_COLUMNS = [
    { key: "num",    label: "번호" },
    { key: "email", label: "이메일 주소" },
]
export default NewsSubscribeDetailModal;

